const Footer = () => {
  return (
    <footer>
      <p>Code by <span className='chief'>ChiefCodar4G</span> &copy; 2022</p>
    </footer>
  )
}

export default Footer
